@if(model.isAdmin){
  <script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.6/ace.js"></script>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.4.0/styles/default.min.css">
  <script src="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.4.0/highlight.min.js"></script>
}

<div class="main">
  <div class="container-1 messages" [class.visible]="isMessagesVisible()">
    @for (m of model.messages(); track m) {
      <div [class.removed]="m.removed">
        {{m.text}}
      </div>
    }
  </div>
  <div class="container-1">
    <app-main-menu></app-main-menu>
  </div>
  <div class="content-container">
    <div [class.visible]="model.isInAppViewState(AppViewStates.code)">
      <app-code></app-code>
    </div>
    <div [class.visible]="model.isInAppViewState(AppViewStates.login)">
      <app-login></app-login>
    </div>
    <div [class.visible]="model.isInAppViewState(AppViewStates.snippets)">
      <app-snippets></app-snippets>
    </div>
    <div [class.visible]="model.isInAppViewState(AppViewStates.settings)">
      <app-settings></app-settings>
    </div>
  </div>
</div>
